module.exports = __webpack_public_path__ + "img/role_button3.5ff342da.png";